module.exports = __webpack_public_path__ + "img/emploisti.dd1b89a5.png";